import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { AnonymousCustomersReport } from '@weft/types';
import { withDefault } from '@weft/utils';
import { VyTable } from 'apps/app/src/components/new-design/table/vy-table/VyTable';
import { useVyNavigate } from 'apps/app/src/hooks/use-vy-navigate';
import { ANONYMOUS_CUSTOMERS_COLUMNS } from './anonymous-customers-columns';

type AnonymousCustomersReportTableProps = {
  rows: AnonymousCustomersReport ;
  filter?: string;
  apiRef?: React.MutableRefObject<GridApiCommunity>;
  isLoading?: boolean;
};

export const AnonymousCustomersReportTable: React.FC<AnonymousCustomersReportTableProps> = ({ isLoading, filter, apiRef, rows }) => {
  const navigate = useVyNavigate();
  const customers = withDefault(rows?.customers, []);

  const filterCustomers = customers.filter(({ name }) => !filter || name.toLowerCase().includes(filter.toLowerCase()));

  return (
    <VyTable
      apiRef={apiRef}
      onRowClick={({ row: { id } }) => navigate(`../../customers/${id}/settings`)}
      columns={ANONYMOUS_CUSTOMERS_COLUMNS}
      items={filterCustomers}
      itemsCount={filterCustomers.length}
      loadingItems={isLoading}
      getRowId={(row) => row.id}
      showPagination={false} 
      hideFooter={false}
      sx={{
        paddingBottom: '80px',
      }}
    />
  );
};
